import { LOOM_BARE_URI } from 'constants/routes';

export default class SessionStorage {
  constructor(id) {
    this.id = id;
  }

  fetchSession() {
    const key = this.sessionKey();

    return this.getKey(key);
  }

  sessionKey() {
    return `${LOOM_BARE_URI}.${this.id}`;
  }

  getKey(key) {
    try {
      const data = window.sessionStorage.getItem(key);

      if (!data) {
        return null;
      }

      return JSON.parse(data);
    } catch (e) {
      // no permissions
      return null;
    }
  }

  setKey(key, data) {
    try {
      return window.sessionStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      // no permissions
      return null;
    }
  }

  removeKey(key) {
    try {
      return window.sessionStorage.removeItem(key);
    } catch (e) {
      // no permissions
      return null;
    }
  }
}
